import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { getBrand } from "@/lib/brand";
import LumetierAppRoutes from "@/routes/LumetierAppRoutes";
import AllureAppRoutes from "@/routes/AllureAppRoutes";
import LenisProvider from "@/providers/LenisProvider";
import HermesLoader from "@/components/editorial/HermesLoader";

// Hoisted so the Toaster doesn't get a fresh object on every App render.
const TOASTER_OPTIONS = { className: "font-sans" };

const BRAND_TITLE = {
  lumetier: "Lumetier · The operating system for photographers",
  allure: "Allure Image · Editorial Photography Studio",
};

// Favicon swap per brand so the browser tab matches the front door.
const BRAND_FAVICON = {
  lumetier: { svg: "/lumetier-icon.svg", png: "/lumetier-icon-32.png" },
  allure: { svg: null, png: "/icon.png" },
};

function setFavicon(brand) {
  const target = BRAND_FAVICON[brand] || BRAND_FAVICON.lumetier;
  // Clear any existing favicon link tags then re-add the brand's.
  document
    .querySelectorAll("link[rel='icon'], link[rel='shortcut icon']")
    .forEach((el) => el.parentNode && el.parentNode.removeChild(el));
  if (target.svg) {
    const svg = document.createElement("link");
    svg.rel = "icon";
    svg.type = "image/svg+xml";
    svg.href = target.svg;
    document.head.appendChild(svg);
  }
  const png = document.createElement("link");
  png.rel = "icon";
  png.type = "image/png";
  png.href = target.png;
  document.head.appendChild(png);
}

function App() {
  const brand = getBrand();

  useEffect(() => {
    // Per-brand <title> + favicon so the browser tab and SEO match the front
    // door the visitor actually landed on (lumetiercreatives.com vs allure-image.com).
    document.title = BRAND_TITLE[brand] || BRAND_TITLE.lumetier;
    setFavicon(brand);
  }, [brand]);

  return (
    <div className="App" data-brand={brand}>
      <AuthProvider>
        <BrowserRouter>
          <LenisProvider>
            <HermesLoader />
            <Toaster richColors position="top-center" toastOptions={TOASTER_OPTIONS} />
            {brand === "lumetier" ? <LumetierAppRoutes /> : <AllureAppRoutes />}
          </LenisProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
